export default "__VITE_ASSET__cS$mzrAQ__"